import { AnalyticsEvent } from '../models';
import { AnalyticsEventType } from '../platforms/adobe-analytics/models';

export class TwoStepVerificationEvent implements AnalyticsEvent {
  name = 'TwoStepVerificationEvent';
  constructor(public readonly twoStepVerificationEvent: AnalyticsEventType) {}
}